import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

import { auth } from '@/api/admin';
import { useAuthStore } from '@/auth/store';

export default function NotAdminPage() {
  const navigate = useNavigate();
  const clear = useAuthStore((s) => s.clear);
  const user = useAuthStore((s) => s.user);

  async function signOut() {
    try {
      await auth.logout();
    } catch {
      // local clear is what matters
    } finally {
      clear();
      navigate('/login', { replace: true });
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center px-4">
      <div className="card max-w-md p-8 text-center">
        <div className="mb-4 flex justify-center">
          <ShieldAlert className="h-10 w-10 text-status-warning" />
        </div>
        <h1 className="text-xl font-semibold">Not an admin</h1>
        <p className="mt-2 text-sm text-text-secondary">
          {user
            ? `${user.email} is signed in but doesn't have admin access.`
            : 'This account does not have admin access.'}
        </p>
        <p className="mt-2 text-sm text-text-secondary">
          Ask another admin to promote you, or add your email to{' '}
          <code className="font-mono">ADMIN_EMAILS</code> in the backend env.
        </p>
        <button onClick={signOut} className="btn-ghost mt-6 w-full">
          Sign out
        </button>
      </div>
    </div>
  );
}
